import { PlusOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Col as ColAnt,
  Divider,
  Form,
  Input,
  message,
  Row,
  Switch,
  Tooltip
} from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import TextArea from 'antd/lib/input/TextArea';
import React, { Fragment, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Label } from '../../components';
import CustomDatePicker from '../../components/CustomDatePicker';
import InputMask from '../../components/input-mask';
import { prefijos3Digitos, validarCaracterEspecial } from '../../utils';

const headerStyle = {
  color: 'rgba(0, 0, 0, 0.85)',
  fontWeight: 500,
  textAlign: 'left',
  background: '#fafafa',
  borderTop: '1px solid #f0f0f0',
  borderBottom: '1px solid #f0f0f0',
  borderRight: '1px solid #f0f0f0'
};

const PasajerosList = ({
  onBack,
  onNext,
  // plan,
  pasajeros,
  setExtraInfo,
  setExtraObsM,
  extraObsM,
  extraInfo,
  cargarDocumentos,
  tieneObsMedicas,
  setTieneObsMedicas
}) => {
  const [form] = Form.useForm();
  const screens = useBreakpoint();
  const [addPasajeros, setAddPasajero] = useState(true);
  const [obsMedicas, setObsMedicas] = useState(pasajeros);
  const [adicionalObsMedicas, setAdicionaObsMedicas] = useState(pasajeros.list);
  const switchextraInfo = async (field, value) => {
    setExtraInfo({ ...extraInfo, [field.key]: value });
  };
  const switchextraObsM = async (field, value) => {
    setExtraObsM({ ...extraObsM, [field.key]: value });
  };

  const onFinish = (values) => {
    // aca se pone el valor de plan.max_pasajeros una vez seteado al seleccionar el plan
    // if (values.list?.length > 2) {
    //   message.warning('El límite máximo de pasajeros es de 2.');
    //   return;
    // }

    const sinFecha = values.list?.some((item) => !item.fechaNacimiento);
    if (sinFecha) {
      message.warning('Debe cargar las fechas de nacimiento');
      return;
    }
    if (onNext) {
      onNext(values);
    }
  };

  // funcion relacionada al max de edad de los pasajeros, a incorporar
  // const checkYears = () => {
  //   const nacimiento = form.getFieldValue('fechaNacimiento');
  //   const cantidadCalculada = nacimiento
  //     .startOf('day')
  //     .diff(moment().startOf('day'), 'years');
  //   if (cantidadCalculada > plan.edadMax) {
  //     return Promise.reject(
  //       new Error('Edad maxima del pasajero supera el limite')
  //     );
  //   }
  //   return Promise.resolve();
  // };

  const onFinishFailed = () => {
    message.warning('Completá todos los campos requeridos.');
  };

  const goBack = () => {
    const { getFieldsValue } = form;
    if (onBack) {
      onBack(getFieldsValue());
    }
  };

  const handletieneObsMedicas = (value) => {
    setTieneObsMedicas(value);
  };

  const checkList = async (add) => {
    const lista = await form.validateFields();
    if (lista) {
      add();
    }
  };

  const deleterow = async (field) => {
    const newArr = [...adicionalObsMedicas];
    newArr.splice(field, 1);
    setAdicionaObsMedicas(newArr);
  };

  const changeObsMedicas = async (value) => {
    setObsMedicas({ ...obsMedicas, observaciones_medicas: value });
  };

  const changeExtraObsMedicas = async (field, value) => {
    if (adicionalObsMedicas) {
      if (adicionalObsMedicas[field.name]) {
        adicionalObsMedicas[field.name] = value;
      } else {
        const aux = adicionalObsMedicas;
        aux.push({ observaciones_medicas: value });
        setAdicionaObsMedicas(aux);
      }
    } else {
      const aux = [];
      aux.push({ observaciones_medicas: value });
      setAdicionaObsMedicas(aux);
    }
  };

  const checkalldata = async () => {
    const datos = form.getFieldValue();
    if (
      datos.nombre &&
      datos.apellido &&
      datos.celular &&
      datos.correo &&
      datos.fechaNacimiento
    ) {
      setAddPasajero(false);
    } else {
      setAddPasajero(true);
    }
  };

  useEffect(() => {
    checkalldata();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  const Col = !screens.md
    ? ColAnt
    : styled((props) => (
        <ColAnt
          {...props}
          style={{
            ...props.style,
            paddingTop: 16,
            paddingBottom: 16,
            paddingLeft: 16,
            paddingRight: 16
          }}
        />
      ))`
        border-right: 1px solid #f0f0f0;
        border-bottom: 1px solid #f0f0f0;
        transition: background 0.3s;
        padding-top: 16px;
        padding-bottom: 16px;
        padding-left: 16px;
        padding-right: 16px;
        &:first-child {
          border-left: 1px solid #f0f0f0;
        }
        &:hover {
          background: #fafafa;
        }
      `;

  const AseguradoForm = ({ field, remove }) => {
    return (
      <>
        <Row
          gutter={[16, 0]}
          style={{
            maxWidth: '1200px',
            marginTop: 'auto',
            marginBottom: 'auto',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <Col xs={24} md={6} align="start" style={headerStyle}>
            Nombre
          </Col>
          <Col xs={24} md={6} align="start" style={headerStyle}>
            Apellido
          </Col>
          <Col xs={26} md={4} align="start" style={headerStyle}>
            Cédula
          </Col>
          <Col
            xs={16}
            md={5}
            align="start"
            style={{ ...headerStyle, textAlign: 'right' }}
          >
            Fecha Nacimiento
          </Col>
          <Col xs={24} md={3} align="flex-end" style={headerStyle} />
        </Row>
        <Row
          gutter={[16, 0]}
          style={{
            maxWidth: '1200px',
            marginTop: 'auto',
            marginBottom: 'auto',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <Col
            xs={24}
            md={6}
            align="start"
            style={screens.md ? { borderLeft: '1px solid #f0f0f0' } : null}
          >
            <Form.Item
              {...field}
              name={[field.name, 'nombre']}
              label={screens.md ? '' : 'Nombre'}
              fieldKey={[field.fieldKey, 'nombre']}
              rules={[{ required: true, message: 'Campo requerido' }]}
              onKeyPress={(e) => {
                const pressedKey = String.fromCharCode(
                  !e.charCode ? e.which : e.charCode
                );
                validarCaracterEspecial(e, pressedKey);
              }}
              onPaste={(e) => {
                const pastedText = e.clipboardData.getData('text');
                validarCaracterEspecial(e, pastedText);
              }}
            >
              <Input placeholder="Nombre" />
            </Form.Item>
          </Col>
          <Col xs={24} md={6} align="start">
            <Form.Item
              {...field}
              name={[field.name, 'apellido']}
              label={screens.md ? '' : 'Apellido'}
              fieldKey={[field.fieldKey, 'apellido']}
              rules={[{ required: true, message: 'Campo requerido' }]}
              onKeyPress={(e) => {
                const pressedKey = String.fromCharCode(
                  !e.charCode ? e.which : e.charCode
                );
                validarCaracterEspecial(e, pressedKey);
              }}
              onPaste={(e) => {
                const pastedText = e.clipboardData.getData('text');
                validarCaracterEspecial(e, pastedText);
              }}
            >
              <Input placeholder="Apellido" />
            </Form.Item>
          </Col>
          <Col xs={24} md={4} align="start">
            <Form.Item noStyle shouldUpdate>
              <>
                <Form.Item
                  {...field}
                  label={screens.md ? '' : 'Cédula'}
                  name={[field.name, 'cedula']}
                  fieldKey={[field.fieldKey, 'cedula']}
                  rules={[{ required: true, message: 'Campo requerido' }]}
                >
                  <Input placeholder="Cédula" />
                </Form.Item>
              </>
            </Form.Item>
          </Col>
          <Col xs={24} md={5} align="start">
            <Form.Item
              {...field}
              label={screens.md ? '' : 'Fecha Nacimiento'}
              name={[field.name, 'fechaNacimiento']}
              fieldKey={[field.fieldKey, 'fechaNacimiento']}
              rules={[{ required: true, message: 'Campo requerido' }]}
            >
              <CustomDatePicker
                style={{ width: '100%' }}
                placeholder="DD/MM/YYYY"
                format="DD/MM/YYYY"
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={3} align="start">
            <Button
              type="dashed"
              danger
              onClick={() => {
                deleterow(field.name);
                remove(field.name);
              }}
            >
              Borrar
            </Button>
          </Col>
        </Row>
        {extraInfo[field.key] && (
          <>
            <Row
              gutter={[16, 0]}
              style={{
                maxWidth: '1200px',
                marginTop: 'auto',
                marginBottom: 'auto',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            >
              <Col xs={24} md={5} align="start" style={headerStyle}>
                Teléfono
              </Col>
              <Col xs={24} md={5} align="start" style={headerStyle}>
                Correo
              </Col>
              <Col xs={24} md={14} align="start" style={headerStyle}>
                Observaciones Médicas (Opcional)
              </Col>
            </Row>
            <Row
              gutter={[16, 0]}
              style={{
                maxWidth: '1200px',
                marginTop: 'auto',
                marginBottom: 'auto',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            >
              <Col xs={24} md={5} align="start" style={headerStyle}>
                <Form.Item
                  name={[field.name, 'celular']}
                  rules={[
                    { required: true, message: 'Requerido' },
                    {
                      pattern: `^\\((${prefijos3Digitos.join(
                        '|'
                      )})\\) [0-9]{3}-[0-9]{3}$`,
                      message: 'Número no válido'
                    }
                  ]}
                >
                  <InputMask
                    mask="(999) 999-999"
                    placeholder="(___) ___-___"
                    addonBefore="+595"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={5} align="start" style={headerStyle}>
                <Form.Item
                  name={[field.name, 'correo']}
                  rules={[
                    { required: true, message: 'Requerido' },
                    {
                      type: 'email',
                      message: 'El correo no es válido'
                    }
                  ]}
                >
                  <Input placeholder="ejemplo@correo.com" type="email" />
                </Form.Item>
              </Col>
              <Col xs={24} md={14} align="start" style={headerStyle}>
                <Form.Item name={[field.name, 'observaciones_medicas']}>
                  <div align="start" style={{ display: 'flex', width: '100%' }}>
                    <div
                      align="start"
                      style={{ border: '0px', padding: '0px', width: '10%' }}
                    >
                      <Switch
                        checkedChildren="Si"
                        unCheckedChildren="No"
                        checked={extraObsM[field.key]}
                        onChange={(e) => {
                          switchextraObsM(field, e);
                        }}
                      />
                    </div>
                    <div
                      align="start"
                      style={{
                        border: '0px',
                        padding: '0px',
                        paddingLeft: '8px',
                        width: '100%'
                      }}
                    >
                      {extraObsM[field.key] && (
                        <TextArea
                          autoSize={{ minRows: 1 }}
                          defaultValue={
                            adicionalObsMedicas
                              ? adicionalObsMedicas[field.name]
                                  ?.observaciones_medicas
                              : ''
                          }
                          placeholder="Observaciones médicas"
                          onBlur={(e) => {
                            changeExtraObsMedicas(field, e.target.value);
                          }}
                          style={{ width: '90%', height: '100%' }}
                        />
                      )}
                    </div>
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </>
        )}
        <Label>
          {' '}
          ¿Desea agregar información adicional del pasajero?{' '}
          <Switch
            checkedChildren="Si"
            unCheckedChildren="No"
            checked={extraInfo[field.key]}
            onChange={(e) => {
              switchextraInfo(field, e);
            }}
          />
        </Label>
        <br />
      </>
    );
  };

  return (
    <>
      <Form
        name="pasajerosList"
        initialValues={pasajeros}
        scrollToFirstError
        onFinish={onFinish}
        onFinishFailed={() => onFinishFailed()}
        form={form}
        layout="vertical"
        autoComplete="off"
      >
        <Divider>Titular</Divider>
        <Row
          gutter={[16, 0]}
          style={{
            maxWidth: '1200px',
            marginTop: 'auto',
            marginBottom: 'auto',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <Col xs={24} md={5} align="start" style={headerStyle}>
            Nombre
          </Col>
          <Col xs={24} md={5} align="start" style={headerStyle}>
            Apellido
          </Col>
          <Col xs={26} md={4} align="start" style={headerStyle}>
            Cédula
          </Col>
          <Col
            xs={16}
            md={5}
            align="start"
            style={{ ...headerStyle, textAlign: 'right' }}
          >
            Fecha Nacimiento
          </Col>
          <Col xs={24} md={5} align="start" style={headerStyle}>
            Teléfono
          </Col>
        </Row>
        <Row
          gutter={[16, 0]}
          style={{
            maxWidth: '1200px',
            marginTop: 'auto',
            marginBottom: 'auto',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <Col xs={24} md={5} align="start">
            <Form.Item
              name="nombre"
              rules={[{ required: true, message: 'Campo requerido' }]}
              onKeyPress={(e) => {
                const pressedKey = String.fromCharCode(
                  !e.charCode ? e.which : e.charCode
                );
                validarCaracterEspecial(e, pressedKey);
              }}
              onPaste={(e) => {
                const pastedText = e.clipboardData.getData('text');
                validarCaracterEspecial(e, pastedText);
              }}
            >
              <Input
                placeholder="Nombre"
                disabled={cargarDocumentos}
                onBlur={() => checkalldata()}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={5} align="start">
            <Form.Item
              name="apellido"
              rules={[{ required: true, message: 'Campo requerido' }]}
              onKeyPress={(e) => {
                const pressedKey = String.fromCharCode(
                  !e.charCode ? e.which : e.charCode
                );
                validarCaracterEspecial(e, pressedKey);
              }}
              onPaste={(e) => {
                const pastedText = e.clipboardData.getData('text');
                validarCaracterEspecial(e, pastedText);
              }}
            >
              <Input
                placeholder="Apellido"
                disabled={cargarDocumentos}
                onBlur={() => checkalldata()}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={4} align="start">
            <Form.Item
              name="cedula"
              rules={[{ required: true, message: 'Campo requerido' }]}
            >
              <Input
                placeholder="Cédula"
                disabled={cargarDocumentos}
                onBlur={() => checkalldata()}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={5} align="start">
            <Form.Item
              name="fechaNacimiento"
              rules={[{ required: true, message: 'Campo requerido' }]}
            >
              <CustomDatePicker
                style={{ width: '100%' }}
                placeholder="DD/MM/YYYY"
                format="DD/MM/YYYY"
                disabled={cargarDocumentos}
                onBlur={() => checkalldata()}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={5} align="start">
            <Form.Item
              name="celular"
              rules={[
                { required: true, message: 'Requerido' },
                {
                  pattern: `^\\((${prefijos3Digitos.join(
                    '|'
                  )})\\) [0-9]{3}-[0-9]{3}$`,
                  message: 'Número no válido'
                }
              ]}
            >
              <InputMask
                mask="(999) 999-999"
                placeholder="(___) ___-___"
                addonBefore="+595"
                onBlur={() => checkalldata()}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row
          gutter={[16, 0]}
          style={{
            maxWidth: '1200px',
            marginTop: 'auto',
            marginBottom: 'auto',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <Col xs={24} md={10} align="start" style={headerStyle}>
            Correo
          </Col>
          <Col xs={24} md={14} align="start" style={headerStyle}>
            Observaciones Médicas (Opcional)
          </Col>
        </Row>
        <Row
          gutter={[16, 0]}
          style={{
            maxWidth: '1200px',
            marginTop: 'auto',
            marginBottom: 'auto',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <Col xs={24} md={10} align="start">
            <Form.Item
              name="correo"
              rules={[
                { required: true, message: 'Requerido' },
                {
                  type: 'email',
                  message: 'El correo no es válido'
                }
              ]}
            >
              <Input
                placeholder="ejemplo@correo.com"
                type="email"
                onBlur={() => checkalldata()}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={14} align="start">
            <Form.Item name="observaciones_medicas">
              <div align="start" style={{ display: 'flex', width: '100%' }}>
                <div
                  align="start"
                  style={{ border: '0px', padding: '0px', width: '10%' }}
                >
                  <Switch
                    checkedChildren="Si"
                    unCheckedChildren="No"
                    checked={tieneObsMedicas}
                    onChange={(e) => {
                      handletieneObsMedicas(e);
                    }}
                  />
                </div>
                <div
                  align="start"
                  style={{
                    border: '0px',
                    padding: '0px',
                    paddingLeft: '8px',
                    width: '100%'
                  }}
                >
                  {tieneObsMedicas && (
                    <TextArea
                      autoSize={{ minRows: 1 }}
                      defaultValue={obsMedicas.observaciones_medicas}
                      placeholder="Observaciones médicas"
                      onBlur={(e) => {
                        changeObsMedicas(e.target.value);
                      }}
                    />
                  )}
                </div>
              </div>
            </Form.Item>
          </Col>
        </Row>
        <Form.List name="list">
          {(fields, { add, remove }) => {
            return (
              <>
                {screens.md && (
                  <>
                    {fields.length > 0 && (
                      <>
                        <Divider>Pasajeros Adicionales</Divider>
                        {fields.map((field) => (
                          <Fragment key={field.key}>
                            <AseguradoForm field={field} remove={remove} />
                          </Fragment>
                        ))}
                        {/* </Row> */}
                      </>
                    )}

                    <ColAnt xs={24} style={{ paddingTop: 20 }}>
                      <Form.Item>
                        <Tooltip
                          title={
                            addPasajeros
                              ? 'Debe completar todos los campos del Titular'
                              : ''
                          }
                        >
                          <Button
                            type="primary"
                            shape="round"
                            disabled={addPasajeros}
                            onClick={() => {
                              checkList(add);
                              // add();
                            }}
                          >
                            <PlusOutlined /> Agregar asegurado adicional
                          </Button>
                        </Tooltip>
                      </Form.Item>
                    </ColAnt>
                  </>
                )}
                {screens.md === false && (
                  <>
                    {fields.map((field) => (
                      <Card
                        key={field.key}
                        bodyStyle={{ paddingBottom: 8 }}
                        style={{ marginBottom: 16 }}
                        actions={[
                          <Button
                            type="dashed"
                            danger
                            onClick={() => {
                              deleterow(field.name, remove);
                              remove(field.name);
                            }}
                          >
                            Borrar
                          </Button>
                        ]}
                      >
                        <Row
                          gutter={[8, 4]}
                          style={{ maxWidth: '1600px', margin: 'auto' }}
                        >
                          <AseguradoForm field={field} />
                        </Row>
                      </Card>
                    ))}
                    <Col xs={24} style={{ paddingTop: 20 }}>
                      <Form.Item>
                        <Button
                          type="primary"
                          shape="round"
                          onClick={() => {
                            checkList(add);
                            // add();
                          }}
                          disabled={addPasajeros}
                        >
                          <PlusOutlined /> Agregar asegurado adicional
                        </Button>
                      </Form.Item>
                    </Col>
                  </>
                )}
              </>
            );
          }}
        </Form.List>

        <Form.Item>
          <Button style={{ margin: 10 }} onClick={goBack}>
            Anterior
          </Button>
          <Button style={{ margin: 10 }} type="primary" htmlType="submit">
            Siguiente
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default PasajerosList;
